export default __webpack_public_path__ + "static/media/logo-proxxima.e2561366.png";